import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "note",
  "use": "note-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"note\">\n  <path d=\"M22,10 L16,4 L4,4 C2.9,4 2,4.9 2,6 L2,18.01 C2,19.11 2.9,20 4,20 L20,19.99 C21.1,19.99 22,19.1 22,18 L22,10 Z M15,5.5 L20.5,11 L15,11 L15,5.5 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol